import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import type { DayjsValue } from '@issuemanager/apps/client/utils';
import { useDateTimeFormat } from './useDateTimeFormat';

type DateValues = {
  date: string;
  time: string;
};

dayjs.extend(utc);
export function useUserDateRenderer(): {
  renderDateTime: (input?: DayjsValue) => string;
  renderDate: (input?: DayjsValue) => string;
  renderDateWithoutTimezone: (input?: DayjsValue) => string;
  getValues: (input?: DayjsValue) => DateValues;
  getDateWithTimezone: (input?: DayjsValue) => dayjs.Dayjs;
} {
  const { date, datetime, timezoneOffset } = useDateTimeFormat();

  const getDateWithTimezone = (input?: DayjsValue): dayjs.Dayjs =>
    dayjs.utc(input).utcOffset(timezoneOffset);

  return {
    renderDateTime: (input?: DayjsValue): string => {
      if (!input) {
        return '';
      }

      return getDateWithTimezone(input).format(datetime);
    },
    renderDate: (input?: DayjsValue): string => {
      if (!input) {
        return '';
      }

      return getDateWithTimezone(input).format(date);
    },
    renderDateWithoutTimezone: (input?: DayjsValue): string => {
      if (!input) {
        return '';
      }

      return dayjs.utc(input).format(date);
    },
    getValues: (input?: DayjsValue): DateValues => {
      const dateValues = {
        date: '',
        time: '',
      };
      if (!input) {
        return dateValues;
      }
      const formatted = getDateWithTimezone(input).format(datetime).split(' ');
      const [formattedDate, time, period] = formatted;
      return {
        date: formattedDate || '',
        time: [time, period].join(' ') || '',
      };
    },
    getDateWithTimezone,
  };
}
